import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { TaskItem } from '../../../home-data/models/submodels/task-item.model';
import { TaskItemStateEnum } from '../../../home-data/home-data.data';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-home-task-list',
  templateUrl: './home-task-list.component.html',
  styleUrls: ['./home-task-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTasksListComponent implements OnInit {
  @Input() taskItems: List<TaskItem>;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  taskItemClick: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();
  @Output()
  taskItemDismiss: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();

  constructor() {}

  ngOnInit() {}

  onTaskItemClick(taskItem: TaskItem) {
    if (taskItem.state === TaskItemStateEnum.completed) {
      return;
    }

    this.taskItemClick.emit(taskItem);
  }
}
